import { render, staticRenderFns } from "./punch-detail.vue?vue&type=template&id=26a1037c&"
import script from "./punch-detail.vue?vue&type=script&lang=js&"
export * from "./punch-detail.vue?vue&type=script&lang=js&"
import style0 from "./punch-detail.vue?vue&type=style&index=0&id=26a1037c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports